import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import MintsoftCredentialsStore from '../../../stores/credentials/mintsoft-credentials-store';

interface IIntegrationProps {
    credentialsStore: MintsoftCredentialsStore,
    vGroup: IValidationGroup,
}

const MintsoftCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Mintsoft API key' required key='api_key'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default MintsoftCredentials;
